module.exports = __webpack_public_path__ + "img/job-active.138a86c9.svg";